<template>
    <div>
        <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
            <!-- 탭 헤더 (Game_Setting.vue 스타일) -->
            <v-toolbar color="grey lighten-5" flat class="elevation-1" dense>
                <v-tabs
                    v-model="activeTab"
                    :color="activeTab === 2 ? 'deep-purple' : 'primary'"
                    :slider-color="activeTab === 2 ? 'deep-purple' : 'primary'"
                    background-color="transparent"
                    icons-and-text
                    show-arrows
                    class="flex-grow-1"
                >
                    <v-tab class="tab-item">
                        <span class="tab-text">일반 이벤트</span>
                        <v-icon class="ml-2" size="20">mdi-calendar-clock</v-icon>
                    </v-tab>
                    <v-tab class="tab-item">
                        <span class="tab-text">미션형 이벤트</span>
                        <v-icon class="ml-2" size="20">mdi-flag-checkered</v-icon>
                    </v-tab>
                    <v-tab class="tab-item tab-item-ticket">
                        <span class="tab-text">캡슐 이벤트</span>
                        <v-icon class="ml-2" size="20">mdi-ticket-confirmation</v-icon>
                    </v-tab>
                </v-tabs>
                <v-spacer></v-spacer>
                <v-btn
                    :color="activeTab === 2 ? 'deep-purple' : 'primary'"
                    small
                    fab
                    @click="activeTab === 0 ? OnClick_CreateEventRolling() : activeTab === 1 ? OnClick_CreateMissionEventRolling() : OnClick_CreateTicketEvent()"
                >
                    <v-icon color="white">mdi-plus</v-icon>
                </v-btn>
            </v-toolbar>

            <v-tabs-items v-model="activeTab">
                <!-- 1번 탭: 일반 이벤트 -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom" dense>
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-calendar-clock</v-icon>
                            <span class="toolbar-text">일반 이벤트</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list>
                        <v-container v-if="loadingData" class="text-center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-container>
                        <v-row v-else>
                            <v-col
                                v-for="item in event_rolling_list"
                                :key="'normal-' + item.PID"
                                cols="12"
                                md="6"
                                lg="4"
                            >
                        <v-card
                            class="mx-auto"
                            :elevation="isEventActive(item) ? 2 : 1"
                            @click="OnClick_EditEventRolling(item, false)"
                            style="cursor: pointer;"
                            :class="{'grey-lighten-4': !isEventActive(item)}"
                        >
                            <v-img
                                v-if="item.THUMB"
                                :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + item.THUMB"
                                height="150"
                                cover
                                :style="!isEventActive(item) ? 'filter: grayscale(100%); opacity: 0.6;' : ''"
                            >
                                <template v-slot:placeholder>
                                    <div class="d-flex align-center justify-center fill-height">
                                        <v-progress-circular
                                            color="grey-lighten-4"
                                            indeterminate
                                        ></v-progress-circular>
                                    </div>
                                </template>
                            </v-img>
                            <v-card-title 
                                :class="eventCardTitleClass(item)"
                            >
                                <v-icon left color="white">mdi-calendar-clock</v-icon>
                                {{ item.TITLE }}
                            </v-card-title>
                            
                            <v-card-text :class="!isEventActive(item) ? 'grey--text text--darken-1' : ''" style="max-width: 100%; overflow-wrap: break-word;">
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="eventCardAccentColor(item)" class="mr-1">mdi-tag</v-icon>
                                    <span class="text-body-2 font-weight-medium">이벤트 태그:</span>
                                    <span class="text-body-2 ml-2">{{ item.EVENT_TAG }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'info' : 'grey'" class="mr-1">mdi-text</v-icon>
                                    <span class="text-body-2 font-weight-medium">설명:</span>
                                    <span class="text-body-2 ml-2">{{ item.DESC }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'success' : 'grey'" class="mr-1">mdi-calendar-start</v-icon>
                                    <span class="text-body-2 font-weight-medium">시작일:</span>
                                    <span class="text-body-2 ml-2">{{ formatDate(item.START_DT) }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'error' : 'grey'" class="mr-1">mdi-calendar-end</v-icon>
                                    <span class="text-body-2 font-weight-medium">종료일:</span>
                                    <span class="text-body-2 ml-2">{{ formatDate(item.END_DT) }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="item.IS_ENABLE === 'Y' ? 'success' : 'error'" class="mr-1">
                                        {{ item.IS_ENABLE === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                    </v-icon>
                                    <span class="text-body-2 font-weight-medium">활성화:</span>
                                    <span :class="['text-body-2 ml-2 font-weight-medium', item.IS_ENABLE === 'Y' ? 'success--text' : 'error--text']">{{ item.IS_ENABLE === 'Y' ? '활성화' : '비활성화' }}</span>
                                </div>
                                <!-- <div v-if="item.INFO" class="mb-2">
                                    <v-icon small :color="isEventActive(item) ? 'info' : 'grey'" class="mr-1">mdi-information</v-icon>
                                    <span class="text-body-2 font-weight-medium">정보:</span>
                                    <div class="text-body-2 ml-4 mt-1" style="max-height: 100px; overflow-y: auto;">
                                        <pre style="white-space: pre-wrap; font-family: inherit; margin: 0;">{{ formatInfo(item.INFO) }}</pre>
                                    </div>
                                </div> -->
                                <div class="mt-3" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small color="grey" class="mr-1">mdi-clock-outline</v-icon>
                                    <span class="text-caption grey--text">생성일: {{ formatDate(item.CREATE_DT) }}</span>
                                </div>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    small
                                    outlined
                                    @click.stop="OnClick_EditEventRolling(item, false)"
                                >
                                    <v-icon small left>mdi-pencil</v-icon>
                                    수정
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-container v-if="!loadingData && event_rolling_list.length === 0" class="text-center">
                    <v-icon large color="grey lighten-1">mdi-information-outline</v-icon>
                    <p class="text-body-1 grey--text mt-2">등록된 일반 이벤트가 없습니다.</p>
                </v-container>
            </v-list>
                </v-tab-item>

                <!-- 2번 탭: 미션형 이벤트 -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom" dense>
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="primary" size="22">mdi-flag-checkered</v-icon>
                            <span class="toolbar-text">미션형 이벤트</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list>
                        <v-container v-if="loadingMissionData" class="text-center">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </v-container>
                        <v-row v-else>
                            <v-col
                                v-for="item in mission_event_rolling_list"
                                :key="'mission-' + item.PID"
                                cols="12"
                                md="6"
                                lg="4"
                            >
                        <v-card
                            class="mx-auto"
                            :elevation="isEventActive(item) ? 2 : 1"
                            @click="OnClick_EditEventRolling(item, true)"
                            style="cursor: pointer;"
                            :class="{'grey-lighten-4': !isEventActive(item)}"
                        >
                            <v-img
                                v-if="item.THUMB"
                                :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + item.THUMB"
                                height="150"
                                cover
                                :style="!isEventActive(item) ? 'filter: grayscale(100%); opacity: 0.6;' : ''"
                            >
                                <template v-slot:placeholder>
                                    <div class="d-flex align-center justify-center fill-height">
                                        <v-progress-circular
                                            color="grey-lighten-4"
                                            indeterminate
                                        ></v-progress-circular>
                                    </div>
                                </template>
                            </v-img>
                            <v-card-title 
                                :class="eventCardTitleClass(item)"
                            >
                                <v-icon left color="white">mdi-calendar-clock</v-icon>
                                {{ item.TITLE }}
                            </v-card-title>
                            
                            <v-card-text :class="!isEventActive(item) ? 'grey--text text--darken-1' : ''" style="max-width: 100%; overflow-wrap: break-word;">
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="eventCardAccentColor(item)" class="mr-1">mdi-numeric</v-icon>
                                    <span class="text-body-2 font-weight-medium">미션 갯수:</span>
                                    <span class="text-body-2 ml-2">{{ parseMissionInfo(item.INFO).mission_count ?? '-' }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'info' : 'grey'" class="mr-1">mdi-format-list-bulleted-type</v-icon>
                                    <span class="text-body-2 font-weight-medium">미션 타입:</span>
                                    <span class="text-body-2 ml-2">{{ missionTypeText(parseMissionInfo(item.INFO).mission_type) }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'info' : 'grey'" class="mr-1">mdi-counter</v-icon>
                                    <span class="text-body-2 font-weight-medium">미션 조건 갯수:</span>
                                    <span class="text-body-2 ml-2">{{ parseMissionInfo(item.INFO).condition_count ?? '-' }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'success' : 'grey'" class="mr-1">mdi-calendar-start</v-icon>
                                    <span class="text-body-2 font-weight-medium">시작일:</span>
                                    <span class="text-body-2 ml-2">{{ formatDate(item.START_DT) }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="isEventActive(item) ? 'error' : 'grey'" class="mr-1">mdi-calendar-end</v-icon>
                                    <span class="text-body-2 font-weight-medium">종료일:</span>
                                    <span class="text-body-2 ml-2">{{ formatDate(item.END_DT) }}</span>
                                </div>
                                <div class="mb-2" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small :color="item.IS_ENABLE === 'Y' ? 'success' : 'error'" class="mr-1">
                                        {{ item.IS_ENABLE === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                    </v-icon>
                                    <span class="text-body-2 font-weight-medium">활성화:</span>
                                    <span :class="['text-body-2 ml-2 font-weight-medium', item.IS_ENABLE === 'Y' ? 'success--text' : 'error--text']">{{ item.IS_ENABLE === 'Y' ? '활성화' : '비활성화' }}</span>
                                </div>
                                <div class="mt-3" style="max-width: 100%; word-break: break-word;">
                                    <v-icon small color="grey" class="mr-1">mdi-clock-outline</v-icon>
                                    <span class="text-caption grey--text">생성일: {{ formatDate(item.CREATE_DT) }}</span>
                                </div>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    small
                                    outlined
                                    @click.stop="OnClick_EditEventRolling(item, true)"
                                >
                                    <v-icon small left>mdi-pencil</v-icon>
                                    수정
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
                <v-container v-if="!loadingMissionData && mission_event_rolling_list.length === 0" class="text-center">
                    <v-icon large color="grey lighten-1">mdi-information-outline</v-icon>
                    <p class="text-body-1 grey--text mt-2">등록된 미션형 이벤트가 없습니다.</p>
                </v-container>
            </v-list>
                </v-tab-item>

                <!-- 3번 탭: 티켓이벤트 (리스트 형태) -->
                <v-tab-item>
                    <v-toolbar color="grey lighten-4" flat class="toolbar-custom" dense>
                        <v-toolbar-title class="toolbar-title-custom">
                            <v-icon left color="deep-purple" size="22">mdi-ticket-confirmation</v-icon>
                            <span class="toolbar-text">캡슐 이벤트</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-list class="pa-0">
                        <v-container v-if="loadingTicketData" class="text-center py-6">
                            <v-progress-circular indeterminate color="deep-purple"></v-progress-circular>
                        </v-container>
                        <template v-else>
                            <v-list-item
                                v-for="item in event_ticket_luckyball_list"
                                :key="'ticket-' + item.PID"
                                :class="[isEventActive(item) ? 'ticket-list-item-active' : 'ticket-list-item-inactive']"
                                @click="OnClick_EditTicketEvent(item)"
                                style="cursor: pointer;"
                            >
                                <v-list-item-avatar size="64" tile class="mr-4">
                                    <v-img
                                        v-if="item.THUMB"
                                        :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + item.THUMB"
                                        contain
                                    />
                                    <v-icon v-else size="40" color="grey lighten-1">mdi-image-off</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="font-weight-bold">{{ item.TITLE }}</v-list-item-title>
                                    <v-list-item-subtitle class="mt-1">{{ item.DESC }}</v-list-item-subtitle>
                                    <div class="mt-2 d-flex flex-wrap">
                                        <span class="text-caption mr-4">
                                            <v-icon x-small>mdi-calendar-start</v-icon>
                                            {{ formatDate(item.START_DT) }}
                                        </span>
                                        <span class="text-caption mr-4">
                                            <v-icon x-small>mdi-calendar-end</v-icon>
                                            {{ formatDate(item.END_DT) }}
                                        </span>
                                        <span class="text-caption mr-4">
                                            <v-icon x-small>mdi-ticket-confirmation</v-icon>
                                            {{ item.TICKET_COUNT != null ? item.TICKET_COUNT : 0 }}장
                                        </span>
                                        <span :class="['text-caption font-weight-medium', getTicketEventStatusClass(item)]">
                                            {{ getTicketEventStatusText(item) }}
                                        </span>
                                    </div>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon small @click.stop="OnClick_EditTicketEvent(item)">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-container v-if="event_ticket_luckyball_list.length === 0" class="text-center py-6">
                                <v-icon large color="grey lighten-1">mdi-ticket-confirmation-outline</v-icon>
                                <p class="text-body-1 grey--text mt-2">등록된 티켓이벤트가 없습니다.</p>
                            </v-container>
                        </template>
                    </v-list>
                </v-tab-item>
            </v-tabs-items>
        </v-card>

        <!-- 이벤트 롤링 생성/수정 다이얼로그 -->
        <v-dialog
            v-model="dialog_event_rolling"
            persistent
            max-width="900"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            @keydown.esc="CloseEventRollingDialog"
        >
            <v-card>
                <v-card-title class="text-h5 primary white--text">
                    <v-icon left color="white">{{ dialog_mode_edit ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
                    {{ current_event_tab === 'mission' ? (dialog_mode_edit ? '미션형 이벤트 수정' : '미션형 이벤트 등록') : (dialog_mode_edit ? '이벤트 롤링 수정' : '이벤트 롤링 등록') }}
                </v-card-title>

                <v-card-text class="pa-6">
                    <!-- [일반 이벤트] 기본 정보 섹션 -->
                    <div v-if="current_event_tab === 'normal'" class="mb-6">
                        <div class="d-flex align-center mb-4">
                            <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
                            <h3 class="text-h6 font-weight-bold">기본 정보</h3>
                            <v-spacer></v-spacer>
                            <v-chip
                                v-if="dialog_mode_edit && dialog_is_main_banner === 'Y'"
                                color="orange darken-2"
                                text-color="white"
                                small
                            >
                                <v-icon small left>mdi-view-dashboard</v-icon>
                                메인배너
                            </v-chip>
                            <v-btn
                                v-else-if="dialog_mode_edit && selected_event_rolling_pid"
                                color="primary"
                                small
                                :loading="loadingMainBanner"
                                @click="OnClick_SetMainBanner"
                            >
                                <v-icon small left>mdi-view-dashboard</v-icon>
                                메인배너로 지정하기
                            </v-btn>
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col cols="12" md="4">
                                <div class="mb-3">
                                    <label class="text-caption grey--text text--darken-1 mb-1 d-block">썸네일 이미지</label>
                                    <v-img
                                        v-if="dialog_thumb_url"
                                        :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + dialog_thumb_url"
                                        alt="썸네일 미리보기"
                                        style="width: 100%; height: 150px; object-fit: cover; border-radius: 8px; border: 2px solid #e0e0e0;"
                                        class="mb-3"
                                    />
                                    <v-file-input
                                        label="이미지 선택"
                                        accept="image/*"
                                        v-model="dialog_thumb_file"
                                        prepend-icon="mdi-image"
                                        outlined
                                        dense
                                        hide-details
                                        @change="handleFileChange"
                                    />
                                </div>
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-text-field
                                    v-model="dialog_event_tag"
                                    label="이벤트 태그 *"
                                    outlined
                                    dense
                                    class="mb-3"
                                    maxlength="50"
                                    counter
                                    prepend-inner-icon="mdi-tag"
                                    :rules="[v => !!v || '이벤트 태그를 입력해주세요']"
                                />
                                <v-text-field
                                    v-model="dialog_title"
                                    label="제목 *"
                                    outlined
                                    dense
                                    class="mb-3"
                                    maxlength="100"
                                    counter
                                    prepend-inner-icon="mdi-format-title"
                                    :rules="[v => !!v || '제목을 입력해주세요']"
                                />
                                <v-textarea
                                    v-model="dialog_desc"
                                    label="설명 *"
                                    outlined
                                    dense
                                    rows="3"
                                    prepend-inner-icon="mdi-text"
                                    :rules="[v => !!v || '설명을 입력해주세요']"
                                />
                                <div :class="['enable-select-wrap mt-3', dialog_is_enable === 'Y' ? 'enable-y' : 'enable-n']">
                                    <v-select
                                        v-model="dialog_is_enable"
                                        :items="yes_no_options"
                                        item-text="label"
                                        item-value="value"
                                        label="활성화 여부"
                                        outlined
                                        dense
                                        prepend-inner-icon="mdi-toggle-switch"
                                        style="max-width: 200px;"
                                    />
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- [미션형 이벤트] 기본 정보 + 기간 · 설정 (정리된 레이아웃) -->
                    <div v-if="current_event_tab === 'mission'" class="mb-4 mission-dialog-top">
                        <div class="d-flex align-center mb-2">
                            <v-icon color="primary" class="mr-2" size="20">mdi-information-outline</v-icon>
                            <h3 class="text-subtitle-1 font-weight-bold mb-0">기본 정보 · 기간 · 설정</h3>
                            <v-spacer></v-spacer>
                            <v-chip
                                v-if="dialog_mode_edit && dialog_is_main_banner === 'Y'"
                                color="orange darken-2"
                                text-color="white"
                                small
                            >
                                <v-icon small left>mdi-view-dashboard</v-icon>
                                메인배너
                            </v-chip>
                            <v-btn
                                v-else-if="dialog_mode_edit && selected_event_rolling_pid && !missionFormLockedWhenActive"
                                color="primary"
                                small
                                :loading="loadingMainBanner"
                                @click="OnClick_SetMainBanner"
                            >
                                <v-icon small left>mdi-view-dashboard</v-icon>
                                메인배너로 지정하기
                            </v-btn>
                        </div>
                        <v-divider class="mb-2"></v-divider>
                        <!-- 1행: [썸네일 전용 왼쪽 영역] | 제목 · 활성화 -->
                        <v-row align="start" no-gutters class="mission-top-row">
                            <v-col cols="12" md="auto" class="mission-thumb-col">
                                <div class="mission-thumb-zone">
                                    <label class="mission-thumb-zone-label">썸네일</label>
                                    <div
                                        class="mission-thumb-wrap"
                                        role="button"
                                        tabindex="0"
                                        @click="!missionFormLockedWhenActive && triggerMissionThumbFileInput()"
                                        @keydown.enter.prevent="!missionFormLockedWhenActive && triggerMissionThumbFileInput()"
                                        @keydown.space.prevent="!missionFormLockedWhenActive && triggerMissionThumbFileInput()"
                                    >
                                        <v-img
                                            v-if="dialog_thumb_url"
                                            :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + dialog_thumb_url"
                                            alt="썸네일"
                                            class="mission-thumb-img"
                                        />
                                        <v-icon v-else size="40" color="grey lighten-1" class="mission-thumb-placeholder">mdi-image-off</v-icon>
                                    </div>
                                    <v-file-input
                                        ref="missionThumbFileInput"
                                        label="이미지"
                                        accept="image/*"
                                        v-model="dialog_thumb_file"
                                        prepend-icon=""
                                        prepend-inner-icon="mdi-image"
                                        outlined
                                        dense
                                        hide-details
                                        class="mission-thumb-input mt-1"
                                        :disabled="missionFormLockedWhenActive"
                                        @change="handleFileChange"
                                    />
                                </div>
                            </v-col>
                            <v-col cols="12" md class="mission-form-col">
                                <v-text-field
                                    v-model="dialog_title"
                                    label="제목 *"
                                    outlined
                                    dense
                                    hide-details
                                    prepend-inner-icon="mdi-format-title"
                                    class="mb-2"
                                    :disabled="missionFormLockedWhenActive"
                                />
                                <div :class="['enable-select-wrap mb-2', dialog_is_enable === 'Y' ? 'enable-y' : 'enable-n']">
                                    <v-select
                                        v-model="dialog_is_enable"
                                        :items="yes_no_options"
                                        item-text="label"
                                        item-value="value"
                                        label="활성화"
                                        outlined
                                        dense
                                        hide-details
                                        style="max-width: 140px;"
                                    />
                                </div>
                                <!-- 시작/종료 기간: 활성화 밑에 배치 -->
                                <div class="mission-period-row">
                                    <div class="d-flex align-center flex-wrap mb-1">
                                        <span class="text-caption grey--text mr-2">시작</span>
                                        <v-menu
                                            v-model="dialog_start_dt_menu"
                                            :close-on-content-click="false"
                                            offset-y
                                            min-width="290px"
                                            :disabled="missionFormLockedWhenActive"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_start_dt"
                                                    label="시작일"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    prepend-inner-icon="mdi-calendar"
                                                    class="mr-2"
                                                    style="max-width: 140px;"
                                                    :disabled="missionFormLockedWhenActive"
                                                />
                                            </template>
                                            <v-date-picker v-model="dialog_start_dt" @input="dialog_start_dt_menu = false" locale="ko-KR" />
                                        </v-menu>
                                        <v-menu
                                            ref="dialog_start_time_menu"
                                            v-model="dialog_start_time_menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="dialog_start_time"
                                            offset-y
                                            :disabled="missionFormLockedWhenActive"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_start_time"
                                                    label="시작시간"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    style="max-width: 100px;"
                                                    :disabled="missionFormLockedWhenActive"
                                                />
                                            </template>
                                            <v-time-picker v-if="dialog_start_time_menu" v-model="dialog_start_time" format="24hr" @click:minute="$refs.dialog_start_time_menu && $refs.dialog_start_time_menu.save(dialog_start_time)" />
                                        </v-menu>
                                    </div>
                                    <div class="d-flex align-center flex-wrap">
                                        <span class="text-caption grey--text mr-2">종료</span>
                                        <v-menu
                                            v-model="dialog_end_dt_menu"
                                            :close-on-content-click="false"
                                            offset-y
                                            min-width="290px"
                                            :disabled="missionFormLockedWhenActive"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_end_dt"
                                                    label="종료일"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    prepend-inner-icon="mdi-calendar"
                                                    class="mr-2"
                                                    style="max-width: 140px;"
                                                    :disabled="missionFormLockedWhenActive"
                                                />
                                            </template>
                                            <v-date-picker v-model="dialog_end_dt" @input="dialog_end_dt_menu = false" locale="ko-KR" :min="dialog_start_dt" />
                                        </v-menu>
                                        <v-menu
                                            ref="dialog_end_time_menu"
                                            v-model="dialog_end_time_menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="dialog_end_time"
                                            offset-y
                                            :disabled="missionFormLockedWhenActive"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_end_time"
                                                    label="종료시간"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    style="max-width: 100px;"
                                                    :disabled="missionFormLockedWhenActive"
                                                />
                                            </template>
                                            <v-time-picker v-if="dialog_end_time_menu" v-model="dialog_end_time" format="24hr" @click:minute="$refs.dialog_end_time_menu && $refs.dialog_end_time_menu.save(dialog_end_time)" />
                                        </v-menu>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <!-- 미션 갯수 -->
                        <v-row class="mt-2" align="center">
                            <v-col cols="12" md="2">
                                <v-text-field
                                    v-model.number="dialog_mission_count"
                                    label="미션 갯수"
                                    type="number"
                                    min="0"
                                    outlined
                                    dense
                                    hide-details
                                    :disabled="missionFormLockedWhenActive"
                                    @input="syncDialogMissionListLength"
                                />
                            </v-col>
                        </v-row>
                        <!-- 미션별 설정 (컴팩트 높이) -->
                        <div class="mt-2 mission-blocks-wrap">
                            <div class="d-flex align-center mb-1">
                                <v-icon color="primary" class="mr-1" size="18">mdi-flag-checkered</v-icon>
                                <span class="text-caption font-weight-bold">미션별 설정</span>
                            </div>
                            <div v-for="(mission, idx) in dialog_mission_list" :key="idx" class="mission-block" :class="isMissionRewardConfigured(mission) ? 'mission-reward-configured' : 'mission-reward-not-configured'">
                                <span class="mission-block-label">미션 {{ idx + 1 }}</span>
                                <v-row dense align="center" class="mission-block-row">
                                    <v-col cols="12" sm="4">
                                        <v-select
                                            v-model="mission.mission_type"
                                            :items="mission_type_options"
                                            item-text="text"
                                            item-value="value"
                                            label="미션 타입"
                                            outlined
                                            dense
                                            hide-details
                                            :disabled="missionFormLockedWhenActive"
                                            @change="OnMissionTypeChange(mission)"
                                        />
                                    </v-col>
                                    <!-- 모든 미션 완료하기: 조건 갯수 1 고정 표기 -->
                                    <template v-if="mission.mission_type === 'ALL_MISSION_COMPLETE'">
                                        <v-col cols="12" sm="3" class="d-flex align-center">
                                            <span class="text-body-2">미션 조건 갯수: <strong>1 (고정)</strong></span>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-select
                                                v-model="mission.reward_type"
                                                :items="reward_type_options"
                                                item-text="text"
                                                item-value="value"
                                                label="보상 타입 (우편)"
                                                outlined
                                                dense
                                                hide-details
                                                :disabled="missionFormLockedWhenActive"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="2" class="d-flex align-center mission-reward-btn-col">
                                            <v-btn small outlined color="primary" class="mission-reward-btn" :disabled="missionFormLockedWhenActive" @click="OpenRewardConfigPopup(idx)">
                                                <v-icon small left>mdi-cog</v-icon>
                                                보상설정
                                            </v-btn>
                                        </v-col>
                                    </template>
                                    <!-- 그 외 미션 타입: 미션 조건 합계 표시 + 상세설정 버튼 -->
                                    <template v-else>
                                        <v-col cols="12" sm="2" class="d-flex align-center">
                                            <span class="text-body-2">미션 조건 합계: <strong>{{ missionConditionSum(mission) }}</strong></span>
                                        </v-col>
                                        <v-col cols="12" sm="2" class="d-flex align-center mission-reward-btn-col">
                                            <v-btn small outlined color="primary" class="mission-reward-btn" :disabled="missionFormLockedWhenActive" @click="OpenDetailConfigPopup(idx)">
                                                <v-icon small left>mdi-cog-outline</v-icon>
                                                상세설정
                                            </v-btn>
                                        </v-col>
                                    </template>
                                </v-row>
                            </div>
                            <p v-if="dialog_mission_list.length === 0" class="text-caption grey--text mt-1 mb-0">미션 갯수를 1 이상으로 설정하면 미션별 설정이 나타납니다.</p>
                        </div>
                    </div>

                    <!-- [일반 이벤트 전용] 기간 설정 섹션 -->
                    <div v-if="current_event_tab === 'normal'" class="mb-6">
                        <div class="d-flex align-center mb-4">
                            <v-icon color="primary" class="mr-2">mdi-calendar-clock</v-icon>
                            <h3 class="text-h6 font-weight-bold">기간 설정</h3>
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col cols="12" md="6">
                                <div class="mb-2">
                                    <label class="text-caption grey--text text--darken-1 mb-1 d-block">시작일시 *</label>
                                </div>
                                <v-row>
                                    <v-col cols="6">
                                        <v-menu
                                            v-model="dialog_start_dt_menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_start_dt"
                                                    label="날짜"
                                                    prepend-inner-icon="mdi-calendar-start"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                    :rules="[v => !!v || '시작일을 선택해주세요']"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="dialog_start_dt"
                                                @input="dialog_start_dt_menu = false"
                                                locale="ko-KR"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-menu
                                            ref="dialog_start_time_menu"
                                            v-model="dialog_start_time_menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="dialog_start_time"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_start_time"
                                                    label="시간"
                                                    prepend-inner-icon="mdi-clock-time-four-outline"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="dialog_start_time_menu"
                                                v-model="dialog_start_time"
                                                full-width
                                                format="24hr"
                                                @click:minute="$refs.dialog_start_time_menu.save(dialog_start_time)"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="6">
                                <div class="mb-2">
                                    <label class="text-caption grey--text text--darken-1 mb-1 d-block">종료일시 *</label>
                                </div>
                                <v-row>
                                    <v-col cols="6">
                                        <v-menu
                                            v-model="dialog_end_dt_menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_end_dt"
                                                    label="날짜"
                                                    prepend-inner-icon="mdi-calendar-end"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                    :rules="[v => !!v || '종료일을 선택해주세요']"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="dialog_end_dt"
                                                @input="dialog_end_dt_menu = false"
                                                locale="ko-KR"
                                                :min="dialog_start_dt"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-menu
                                            ref="dialog_end_time_menu"
                                            v-model="dialog_end_time_menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="dialog_end_time"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="dialog_end_time"
                                                    label="시간"
                                                    prepend-inner-icon="mdi-clock-time-four-outline"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </template>
                                            <v-time-picker
                                                v-if="dialog_end_time_menu"
                                                v-model="dialog_end_time"
                                                full-width
                                                format="24hr"
                                                @click:minute="$refs.dialog_end_time_menu.save(dialog_end_time)"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- [일반 이벤트 전용] 설정 섹션 -->
                    <div v-if="current_event_tab === 'normal'" class="mb-6">
                        <div class="d-flex align-center mb-4">
                            <v-icon color="primary" class="mr-2">mdi-cog</v-icon>
                            <h3 class="text-h6 font-weight-bold">설정</h3>
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-select
                                    v-model="dialog_action_type"
                                    :items="action_type_options"
                                    item-text="text"
                                    item-value="value"
                                    label="액션타입"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-gesture-tap"
                                    class="mb-3"
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="dialog_action_key"
                                    label="액션타입에 따른 키"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-key"
                                    placeholder="텍스트 입력"
                                />
                            </v-col>
                        </v-row>
                    </div>

                    <!-- 추가 정보 섹션 (일반 이벤트만) -->
                    <div v-if="current_event_tab === 'normal'" class="mb-6">
                        <div class="d-flex align-center mb-4">
                            <v-icon color="primary" class="mr-2">mdi-code-json</v-icon>
                            <h3 class="text-h6 font-weight-bold">추가 정보 (선택사항)</h3>
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-textarea
                            v-model="dialog_info_text"
                            label="정보 (JSON 형식)"
                            outlined
                            dense
                            rows="5"
                            prepend-inner-icon="mdi-code-json"
                            hint="JSON 형식으로 입력하세요. 예: {&quot;key&quot;: &quot;value&quot;}"
                            persistent-hint
                        />
                    </div>
                </v-card-text>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <template v-if="missionFormLockedWhenActive">
                        <v-btn color="grey" text @click="CloseEventRollingDialog">닫기</v-btn>
                        <v-btn color="primary" @click="OnSave_EventRolling" :loading="loadingData">저장</v-btn>
                    </template>
                    <template v-else>
                        <v-btn color="grey" text @click="CloseEventRollingDialog">취소</v-btn>
                        <v-btn color="primary" @click="OnSave_EventRolling" :loading="loadingData">저장</v-btn>
                    </template>
                </v-card-actions>

                <!-- 보상 설정 작은 팝업 (팝업 위 팝업, 우편 타입별 설정 참고) -->
                <v-dialog
                    v-model="reward_config_popup"
                    persistent
                    max-width="520"
                    :fullscreen="$vuetify.breakpoint.xsOnly"
                    content-class="reward-config-dialog"
                >
                    <v-card v-if="reward_config_mission_index >= 0 && dialog_mission_list[reward_config_mission_index]">
                        <v-card-title class="subtitle-1 primary white--text py-2">
                            <v-icon left color="white" small>mdi-gift</v-icon>
                            보상 설정 — 미션 {{ reward_config_mission_index + 1 }}{{ reward_config_step_index >= 0 ? ' · 단계 ' + (reward_config_step_index + 1) : '' }}
                        </v-card-title>
                        <v-card-text class="pa-4">
                            <template v-if="currentRewardMission && currentRewardMission.reward_type === 'npc'">
                                <v-text-field
                                    v-model="currentRewardMission.npc_name"
                                    label="NPC 이름"
                                    placeholder="예: 제갈페페"
                                    outlined
                                    dense
                                    hide-details
                                    class="mb-2"
                                />
                                <v-text-field
                                    v-model.number="currentRewardMission.bonus_pct"
                                    label="지급보너스 (%)"
                                    type="number"
                                    outlined
                                    dense
                                    hide-details
                                    class="mb-2"
                                />
                                <v-text-field
                                    v-model.number="currentRewardMission.duration_sec"
                                    label="유지시간 (Sec)"
                                    type="number"
                                    outlined
                                    dense
                                    hide-details
                                    class="mb-2"
                                />
                                <div class="d-flex flex-wrap mt-1">
                                    <v-btn x-small :color="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 86400) ? 'success' : 'grey'" :dark="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 86400)" :outlined="!isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 86400)" class="mr-1 mb-1" @click="SetRewardDuration(reward_config_mission_index, 86400)">하루</v-btn>
                                    <v-btn x-small :color="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 604800) ? 'success' : 'grey'" :dark="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 604800)" :outlined="!isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 604800)" class="mr-1 mb-1" @click="SetRewardDuration(reward_config_mission_index, 604800)">일주일</v-btn>
                                    <v-btn x-small :color="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 2592000) ? 'success' : 'grey'" :dark="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 2592000)" :outlined="!isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 2592000)" class="mb-1" @click="SetRewardDuration(reward_config_mission_index, 2592000)">한달</v-btn>
                                </div>
                            </template>
                            <template v-else>
                                <v-text-field
                                    v-if="currentRewardMission"
                                    v-model.number="currentRewardMission.bonus_pct"
                                    label="지급보너스 (%)"
                                    type="number"
                                    outlined
                                    dense
                                    hide-details
                                    class="mb-2"
                                />
                                <v-text-field
                                    v-if="currentRewardMission"
                                    v-model.number="currentRewardMission.duration_sec"
                                    label="유지시간 (Sec)"
                                    type="number"
                                    outlined
                                    dense
                                    hide-details
                                    class="mb-2"
                                />
                                <div class="d-flex flex-wrap mt-1">
                                    <v-btn x-small :color="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 86400) ? 'success' : 'grey'" :dark="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 86400)" :outlined="!isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 86400)" class="mr-1 mb-1" @click="SetRewardDuration(reward_config_mission_index, 86400)">하루</v-btn>
                                    <v-btn x-small :color="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 604800) ? 'success' : 'grey'" :dark="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 604800)" :outlined="!isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 604800)" class="mr-1 mb-1" @click="SetRewardDuration(reward_config_mission_index, 604800)">일주일</v-btn>
                                    <v-btn x-small :color="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 2592000) ? 'success' : 'grey'" :dark="isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 2592000)" :outlined="!isDurationSelected(currentRewardMission && Number(currentRewardMission.duration_sec), 2592000)" class="mb-1" @click="SetRewardDuration(reward_config_mission_index, 2592000)">한달</v-btn>
                                </div>
                            </template>
                        </v-card-text>
                        <v-card-actions class="pa-3">
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text small @click="reward_config_popup = false">닫기</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- 상세설정 다이얼로그 (단계형 미션: 단계 수 + 단계별 컨디션/보상) -->
                <v-dialog
                    v-model="detail_config_popup"
                    persistent
                    max-width="920"
                    :fullscreen="$vuetify.breakpoint.xsOnly"
                    content-class="detail-config-dialog"
                >
                    <v-card v-if="detail_mission_index >= 0 && dialog_mission_list[detail_mission_index]">
                        <v-card-title class="subtitle-1 primary white--text py-2">
                            <v-icon left color="white" small>mdi-format-list-numbered</v-icon>
                            상세설정 — 미션 {{ detail_mission_index + 1 }}
                        </v-card-title>
                        <v-card-text class="pa-4">
                            <template v-if="currentDetailMission">
                                <v-text-field
                                    v-model.number="currentDetailMission.detail_step_count"
                                    label="단계 수"
                                    type="number"
                                    min="1"
                                    outlined
                                    dense
                                    hide-details
                                    class="mb-3"
                                    @input="syncDetailSteps"
                                />
                                <div class="detail-steps-wrap">
                                    <div v-for="(step, stepIdx) in currentDetailMission.steps" :key="stepIdx" class="detail-step-row">
                                        <v-row dense align="center" no-gutters class="detail-step-fields ma-0">
                                            <v-col cols="auto" class="detail-step-num-col">
                                                <span class="detail-step-num">단계 {{ stepIdx + 1 }}</span>
                                            </v-col>
                                            <v-col cols="2" sm="1">
                                                <v-text-field
                                                    v-model.number="step.condition_count"
                                                    label="개별조건"
                                                    type="number"
                                                    min="0"
                                                    outlined
                                                    dense
                                                    hide-details
                                                />
                                            </v-col>
                                            <v-col cols="3" sm="2">
                                                <v-select
                                                    v-model="step.reward_type"
                                                    :items="reward_type_options"
                                                    item-text="text"
                                                    item-value="value"
                                                    label="보상 타입"
                                                    outlined
                                                    dense
                                                    hide-details
                                                />
                                            </v-col>
                                            <v-col v-if="step.reward_type === 'npc'" cols="4" sm="2">
                                                <v-text-field
                                                    v-model="step.npc_name"
                                                    label="NPC 이름"
                                                    placeholder="이름"
                                                    outlined
                                                    dense
                                                    hide-details
                                                />
                                            </v-col>
                                            <v-col cols="2" sm="1">
                                                <v-text-field
                                                    v-model.number="step.bonus_pct"
                                                    label="보너스%"
                                                    type="number"
                                                    outlined
                                                    dense
                                                    hide-details
                                                />
                                            </v-col>
                                            <v-col cols="3" sm="2">
                                                <v-text-field
                                                    v-model.number="step.duration_sec"
                                                    label="유지시간(Sec)"
                                                    type="number"
                                                    outlined
                                                    dense
                                                    hide-details
                                                />
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-btn x-small :color="isDurationSelected(step.duration_sec, 86400) ? 'success' : 'grey'" :dark="isDurationSelected(step.duration_sec, 86400)" :outlined="!isDurationSelected(step.duration_sec, 86400)" class="mr-1" @click="SetStepRewardDuration(detail_mission_index, stepIdx, 86400)">하루</v-btn>
                                                <v-btn x-small :color="isDurationSelected(step.duration_sec, 604800) ? 'success' : 'grey'" :dark="isDurationSelected(step.duration_sec, 604800)" :outlined="!isDurationSelected(step.duration_sec, 604800)" class="mr-1" @click="SetStepRewardDuration(detail_mission_index, stepIdx, 604800)">일주일</v-btn>
                                                <v-btn x-small :color="isDurationSelected(step.duration_sec, 2592000) ? 'success' : 'grey'" :dark="isDurationSelected(step.duration_sec, 2592000)" :outlined="!isDurationSelected(step.duration_sec, 2592000)" @click="SetStepRewardDuration(detail_mission_index, stepIdx, 2592000)">한달</v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                            </template>
                        </v-card-text>
                        <v-card-actions class="pa-3">
                            <span v-if="currentDetailMission && currentDetailMission.steps" class="text-body-2 mr-3">
                                <strong>조건의 합:</strong> {{ detailConditionSum }}
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn color="grey" text small @click="detail_config_popup = false">닫기</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card>
        </v-dialog>

        <!-- 티켓이벤트 생성/수정 다이얼로그 -->
        <v-dialog
            v-model="dialog_ticket_event"
            persistent
            max-width="600"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            @keydown.esc="CloseTicketDialog"
        >
            <v-card>
                <v-card-title class="text-h5 deep-purple white--text">
                    <v-icon left color="white">{{ ticket_dialog_mode_edit ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
                    {{ ticket_dialog_mode_edit ? '캡슐 이벤트 수정' : '캡슐 이벤트 등록' }}
                </v-card-title>
                <v-card-text class="pa-4">
                    <v-text-field
                        v-model="ticket_dialog_title"
                        label="제목 *"
                        outlined
                        dense
                        class="mb-3"
                        prepend-inner-icon="mdi-format-title"
                        :rules="[v => !!v || '제목을 입력해주세요']"
                    />
                    <v-textarea
                        v-model="ticket_dialog_desc"
                        label="설명 *"
                        outlined
                        dense
                        rows="3"
                        class="mb-3"
                        prepend-inner-icon="mdi-text"
                        :rules="[v => !!v || '설명을 입력해주세요']"
                    />
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <div class="mb-3">
                                <label class="text-caption grey--text mb-1 d-block">썸네일</label>
                                <v-img
                                    v-if="ticket_dialog_thumb_url"
                                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + ticket_dialog_thumb_url"
                                    height="120"
                                    contain
                                    class="mb-2"
                                    style="border-radius: 8px; border: 1px solid #e0e0e0;"
                                />
                                <v-file-input
                                    label="이미지 선택"
                                    accept="image/*"
                                    v-model="ticket_dialog_thumb_file"
                                    prepend-icon="mdi-image"
                                    outlined
                                    dense
                                    hide-details
                                />
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="mb-3">
                                <label class="text-caption grey--text mb-1 d-block">배너 이미지 (thumb_banner)</label>
                                <v-img
                                    v-if="ticket_dialog_thumb_banner_url"
                                    :src="'https://content-filecenter.s3.ap-northeast-2.amazonaws.com/' + ticket_dialog_thumb_banner_url"
                                    height="120"
                                    contain
                                    class="mb-2"
                                    style="border-radius: 8px; border: 1px solid #e0e0e0;"
                                />
                                <v-file-input
                                    label="이미지 선택"
                                    accept="image/*"
                                    v-model="ticket_dialog_thumb_banner_file"
                                    prepend-icon="mdi-image"
                                    outlined
                                    dense
                                    hide-details
                                />
                            </div>
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="6">
                            <v-menu v-model="ticket_start_dt_menu" :close-on-content-click="false" max-width="290">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="(ticket_dialog_start_dt || '') + (ticket_dialog_start_dt && ticket_dialog_start_time ? ' ' + ticket_dialog_start_time : '')"
                                        label="시작일시 *"
                                        readonly
                                        outlined
                                        dense
                                        hide-details
                                        v-bind="attrs"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker v-model="ticket_dialog_start_dt" @input="ticket_start_dt_menu = false" />
                            </v-menu>
                            <v-text-field v-model="ticket_dialog_start_time" label="시작 시간" type="time" outlined dense hide-details class="mt-1" />
                        </v-col>
                        <v-col cols="6">
                            <v-menu v-model="ticket_end_dt_menu" :close-on-content-click="false" max-width="290">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="(ticket_dialog_end_dt || '') + (ticket_dialog_end_dt && ticket_dialog_end_time ? ' ' + ticket_dialog_end_time : '')"
                                        label="종료일시 *"
                                        readonly
                                        outlined
                                        dense
                                        hide-details
                                        v-bind="attrs"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker v-model="ticket_dialog_end_dt" @input="ticket_end_dt_menu = false" />
                            </v-menu>
                            <v-text-field v-model="ticket_dialog_end_time" label="종료 시간" type="time" outlined dense hide-details class="mt-1" />
                        </v-col>
                    </v-row>
                    <v-text-field
                        v-model.number="ticket_dialog_ticket_count"
                        label="티켓 수"
                        type="number"
                        min="0"
                        outlined
                        dense
                        class="mt-3"
                        prepend-inner-icon="mdi-ticket-confirmation"
                        hint="정수 값 (0 이상)"
                        persistent-hint
                    />
                    <v-select
                        v-model="ticket_dialog_is_enable"
                        :items="yes_no_options"
                        item-text="label"
                        item-value="value"
                        label="활성화"
                        outlined
                        dense
                        class="mt-3"
                    />
                </v-card-text>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="CloseTicketDialog">취소</v-btn>
                    <v-btn color="deep-purple" @click="OnSave_TicketEvent">저장</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
const { FileUpload_Async } = require("../../util/fileutil");

export default {
    name: 'Game_EventRolling',

    data: () => ({
        activeTab: 0,
        loadingData: false,
        loadingMissionData: false,
        loadingMainBanner: false,
        event_rolling_list: [],
        mission_event_rolling_list: [],
        current_event_tab: 'normal', // 'normal' | 'mission' (어떤 탭에서 연 다이얼로그인지)
        dialog_event_rolling: false,
        dialog_mode_edit: false,
        dialog_event_tag: '',
        dialog_title: '',
        dialog_desc: '',
        dialog_thumb_file: null,
        dialog_thumb_url: '',
        dialog_start_dt: '',
        dialog_start_time: '00:00',
        dialog_end_dt: '',
        dialog_end_time: '23:59',
        dialog_is_enable: 'Y',
        /** 미션형 수정 시, 다이얼로그를 열었을 때 이미 활성화였는지 (이 값이 true면 폼 잠금, 활성화 토글만 저장 가능) */
        dialog_was_enabled_on_open: false,
        dialog_info_text: '',
        dialog_start_dt_menu: false,
        dialog_start_time_menu: false,
        dialog_end_dt_menu: false,
        dialog_end_time_menu: false,
        selected_event_rolling_pid: null,
        dialog_is_main_banner: 'N',
        yes_no_options: [
            { label: '활성화', value: 'Y' },
            { label: '비활성화', value: 'N' }
        ],
        action_type_options: [
            { text: '링크', value: 'link' },
            { text: '플레이스먼트', value: 'placement' },
            { text: '오퍼월', value: 'offerwall' },
            { text: 'Custom', value: 'custom' },
        ],
        dialog_action_type: 'link',
        dialog_action_key: '',
        _syncing_from_json: false, // JSON → 설정 동기화 중 플래그 (watch 루프 방지)
        // 미션형 이벤트: 갯수에 따라 설정할 미션 목록
        dialog_mission_count: 0,
        dialog_mission_list: [], // [{ mission_type, condition_count, reward_type }, ...]
        // 미션 타입 (요청 기준)
        mission_type_options: [
            { text: '광고보고 채굴기 강화', value: 'AD_WATCH_MINING' },
            { text: '포인트 지갑으로 저장', value: 'POINT_WALLET_SAVE' },
            { text: '친구 포인트 저장하기', value: 'FRIEND_POINT_SAVE' },
            { text: '강화소해서 채굴기 강화', value: 'UPGRADE_MINING' },
            { text: '모든 미션 완료하기', value: 'ALL_MISSION_COMPLETE' },
        ],
        // 보상 타입: 우편 보내는 곳 참고 (채굴기 / NPC 등)
        reward_type_options: [
            { text: '채굴기', value: 'mining' },
            { text: 'NPC', value: 'npc' },
        ],
        // 보상 설정 작은 팝업 (팝업 위 팝업)
        reward_config_popup: false,
        reward_config_mission_index: -1,
        reward_config_step_index: -1, // -1: 미션 자체 보상, >=0: 단계형 미션의 steps[stepIdx]
        // 상세설정 팝업 (단계형 미션)
        detail_config_popup: false,
        detail_mission_index: -1,
        // 티켓이벤트
        loadingTicketData: false,
        event_ticket_luckyball_list: [],
        dialog_ticket_event: false,
        ticket_dialog_mode_edit: false,
        ticket_dialog_pid: null,
        ticket_dialog_title: '',
        ticket_dialog_desc: '',
        ticket_dialog_thumb_file: null,
        ticket_dialog_thumb_url: '',
        ticket_dialog_thumb_banner_file: null,
        ticket_dialog_thumb_banner_url: '',
        ticket_dialog_start_dt: '',
        ticket_dialog_start_time: '00:00',
        ticket_dialog_end_dt: '',
        ticket_dialog_end_time: '23:59',
        ticket_dialog_is_enable: 'Y',
        ticket_dialog_info_text: '',
        ticket_dialog_ticket_count: 0,
        ticket_start_dt_menu: false,
        ticket_end_dt_menu: false,
    }),

    created() {
        this.LoadEventRollingList();
        this.LoadMissionEventRollingList();
        this.LoadTicketLuckyballList();
    },

    methods: {
        ...mapActions([
            'GET_EVENT_ROLLING_LIST',
            'CREATE_EVENT_ROLLING',
            'EDIT_EVENT_ROLLING',
            'CPU_SET_MAIN_BANNER',
            'GET_EVENT_MISSION_LIST',
            'CREATE_EVENT_MISSION',
            'EDIT_EVENT_MISSION',
            'GET_EVENT_TICKET_LUCKYBALL_LIST',
            'CREATE_EVENT_TICKET_LUCKYBALL',
            'EDIT_EVENT_TICKET_LUCKYBALL',
        ]),

        LoadEventRollingList() {
            this.loadingData = true;
            this.GET_EVENT_ROLLING_LIST({})
                .then((body_data) => {
                    this.loadingData = false;
                    this.event_rolling_list = body_data.event_rolling_list 
                        || body_data.response_data?.event_rolling_list 
                        || (body_data.response_data && Array.isArray(body_data.response_data) ? body_data.response_data : [])
                        || [];
                    console.log('일반 이벤트 롤링 리스트 로드:', this.event_rolling_list);
                })
                .catch((err) => {
                    this.loadingData = false;
                    console.error('일반 이벤트 롤링 리스트 로드 실패:', err);
                    alert('일반 이벤트 롤링 리스트를 불러오는데 실패했습니다.');
                });
        },
        LoadMissionEventRollingList() {
            this.loadingMissionData = true;
            this.GET_EVENT_MISSION_LIST()
                .then((body_data) => {
                    this.loadingMissionData = false;
                    this.mission_event_rolling_list = body_data.event_mission_list 
                        || body_data.response_data?.event_mission_list 
                        || (body_data.response_data && Array.isArray(body_data.response_data) ? body_data.response_data : [])
                        || [];
                    console.log('이벤트 미션 리스트 로드:', this.mission_event_rolling_list);
                })
                .catch((err) => {
                    this.loadingMissionData = false;
                    console.error('미션형 이벤트 롤링 리스트 로드 실패:', err);
                    alert('미션형 이벤트 롤링 리스트를 불러오는데 실패했습니다.');
                });
        },

        LoadTicketLuckyballList() {
            this.loadingTicketData = true;
            this.GET_EVENT_TICKET_LUCKYBALL_LIST()
                .then((body_data) => {
                    this.loadingTicketData = false;
                    this.event_ticket_luckyball_list = body_data.event_ticket_luckyball_list
                        || body_data.response_data?.event_ticket_luckyball_list
                        || [];
                })
                .catch((err) => {
                    this.loadingTicketData = false;
                    console.error('티켓이벤트 리스트 로드 실패:', err);
                    alert('티켓이벤트 리스트를 불러오는데 실패했습니다.');
                });
        },

        OnClick_CreateTicketEvent() {
            this.ticket_dialog_mode_edit = false;
            this.ticket_dialog_pid = null;
            this.ticket_dialog_title = '';
            this.ticket_dialog_desc = '';
            this.ticket_dialog_thumb_file = null;
            this.ticket_dialog_thumb_url = '';
            this.ticket_dialog_thumb_banner_file = null;
            this.ticket_dialog_thumb_banner_url = '';
            this.ticket_dialog_start_dt = '';
            this.ticket_dialog_start_time = '00:00';
            this.ticket_dialog_end_dt = '';
            this.ticket_dialog_end_time = '23:59';
            this.ticket_dialog_is_enable = 'Y';
            this.ticket_dialog_info_text = '';
            this.ticket_dialog_ticket_count = 0;
            this.dialog_ticket_event = true;
        },

        OnClick_EditTicketEvent(item) {
            this.ticket_dialog_mode_edit = true;
            this.ticket_dialog_pid = item.PID;
            this.ticket_dialog_title = item.TITLE || '';
            this.ticket_dialog_desc = item.DESC || '';
            this.ticket_dialog_thumb_file = null;
            this.ticket_dialog_thumb_url = item.THUMB || '';
            this.ticket_dialog_thumb_banner_file = null;
            this.ticket_dialog_thumb_banner_url = item.THUMB_BANNER || '';
            if (item.START_DT) {
                const parts = item.START_DT.split(' ');
                this.ticket_dialog_start_dt = parts[0] || '';
                this.ticket_dialog_start_time = parts[1] ? parts[1].substring(0, 5) : '00:00';
            } else {
                this.ticket_dialog_start_dt = '';
                this.ticket_dialog_start_time = '00:00';
            }
            if (item.END_DT) {
                const parts = item.END_DT.split(' ');
                this.ticket_dialog_end_dt = parts[0] || '';
                this.ticket_dialog_end_time = parts[1] ? parts[1].substring(0, 5) : '23:59';
            } else {
                this.ticket_dialog_end_dt = '';
                this.ticket_dialog_end_time = '23:59';
            }
            this.ticket_dialog_is_enable = item.IS_ENABLE || 'Y';
            this.ticket_dialog_info_text = item.INFO ? (typeof item.INFO === 'string' ? item.INFO : JSON.stringify(item.INFO)) : '';
            this.ticket_dialog_ticket_count = item.TICKET_COUNT != null ? Number(item.TICKET_COUNT) : 0;
            this.dialog_ticket_event = true;
        },

        CloseTicketDialog() {
            this.dialog_ticket_event = false;
        },

        async OnSave_TicketEvent() {
            if (!this.ticket_dialog_title || !this.ticket_dialog_desc) {
                alert('제목과 설명은 필수입니다.');
                return;
            }
            const start_dt = `${this.ticket_dialog_start_dt} ${this.ticket_dialog_start_time || '00:00'}:00`;
            const end_dt = `${this.ticket_dialog_end_dt} ${this.ticket_dialog_end_time || '23:59'}:00`;
            if (!this.ticket_dialog_start_dt || !this.ticket_dialog_end_dt) {
                alert('시작일시와 종료일시를 입력해주세요.');
                return;
            }
            if (new Date(start_dt) >= new Date(end_dt)) {
                alert('시작일시는 종료일시보다 이전이어야 합니다.');
                return;
            }
            let thumb = this.ticket_dialog_thumb_url || '';
            if (this.ticket_dialog_thumb_file) {
                const thumbPath = 'cpu/event/thumb/' + this.Utill_CreateNewImageName(this.ticket_dialog_thumb_file.name || 'thumb.png');
                await FileUpload_Async(this.ticket_dialog_thumb_file, thumbPath);
                thumb = thumbPath;
            }
            let thumb_banner = this.ticket_dialog_thumb_banner_url || '';
            if (this.ticket_dialog_thumb_banner_file) {
                const bannerPath = 'cpu/event/thumb_banner/' + this.Utill_CreateNewImageName(this.ticket_dialog_thumb_banner_file.name || 'thumb_banner.png');
                await FileUpload_Async(this.ticket_dialog_thumb_banner_file, bannerPath);
                thumb_banner = bannerPath;
            }
            let info = null;
            if (this.ticket_dialog_info_text) {
                try {
                    info = typeof this.ticket_dialog_info_text === 'string' ? JSON.parse(this.ticket_dialog_info_text) : this.ticket_dialog_info_text;
                } catch (e) {
                    info = this.ticket_dialog_info_text;
                }
            }
            try {
                const ticket_count = Math.max(0, parseInt(this.ticket_dialog_ticket_count, 10) || 0);
                if (this.ticket_dialog_mode_edit) {
                    await this.EDIT_EVENT_TICKET_LUCKYBALL({
                        pid: this.ticket_dialog_pid,
                        title: this.ticket_dialog_title,
                        desc: this.ticket_dialog_desc,
                        thumb,
                        thumb_banner,
                        start_dt,
                        end_dt,
                        is_enable: this.ticket_dialog_is_enable,
                        info,
                        ticket_count
                    });
                } else {
                    await this.CREATE_EVENT_TICKET_LUCKYBALL({
                        title: this.ticket_dialog_title,
                        desc: this.ticket_dialog_desc,
                        thumb,
                        thumb_banner,
                        start_dt,
                        end_dt,
                        is_enable: this.ticket_dialog_is_enable,
                        info,
                        ticket_count
                    });
                }
                alert('저장되었습니다.');
                this.CloseTicketDialog();
                this.LoadTicketLuckyballList();
            } catch (e) {
                alert(e?.message || e || '저장에 실패했습니다.');
            }
        },

        OnClick_CreateEventRolling() {
            this.current_event_tab = 'normal';
            this.dialog_mode_edit = false;
            this.selected_event_rolling_pid = null;
            this.dialog_event_tag = '';
            this.dialog_title = '';
            this.dialog_desc = '';
            this.dialog_thumb_file = null;
            this.dialog_thumb_url = '';
            this.dialog_start_dt = '';
            this.dialog_start_time = '00:00';
            this.dialog_end_dt = '';
            this.dialog_end_time = '23:59';
            this.dialog_is_enable = 'Y';
            this.dialog_action_type = 'link';
            this.dialog_action_key = '';
            this.dialog_info_text = JSON.stringify({ action_type: 'link', action_key: '' }, null, 2);
            this.dialog_is_main_banner = 'N';
            this.dialog_was_enabled_on_open = false;
            this.dialog_event_rolling = true;
        },
        OnClick_CreateMissionEventRolling() {
            this.current_event_tab = 'mission';
            this.dialog_mode_edit = false;
            this.dialog_was_enabled_on_open = false;
            this.selected_event_rolling_pid = null;
            this.dialog_title = '';
            this.dialog_thumb_file = null;
            this.dialog_thumb_url = '';
            this.dialog_start_dt = '';
            this.dialog_start_time = '00:00';
            this.dialog_end_dt = '';
            this.dialog_end_time = '23:59';
            this.dialog_is_enable = 'N';
            this.dialog_mission_count = 1;
            this.dialog_mission_list = [this.defaultMissionItem()];
            this.dialog_is_main_banner = 'N';
            this.dialog_event_rolling = true;
        },
        defaultMissionItem() {
            const def = this.defaultRewardConfig('mining');
            return {
                mission_type: 'AD_WATCH_MINING',
                condition_count: 3,
                reward_type: 'mining',
                bonus_pct: def.bonus_pct,
                duration_sec: def.duration_sec,
                npc_name: def.npc_name,
                detail_step_count: 1,
                steps: [this.defaultStepItem()]
            };
        },
        defaultStepItem() {
            const def = this.defaultRewardConfig('mining');
            return {
                condition_count: 3,
                reward_type: 'mining',
                bonus_pct: def.bonus_pct,
                duration_sec: def.duration_sec,
                npc_name: def.npc_name
            };
        },
        /** reward_config 필드를 mission/step 루트로 평탄화 */
        flattenReward(obj, rewardType) {
            const def = this.defaultRewardConfig(rewardType || 'mining');
            const rc = obj.reward_config;
            return {
                bonus_pct: obj.bonus_pct ?? rc?.bonus_pct ?? def.bonus_pct,
                duration_sec: obj.duration_sec ?? rc?.duration_sec ?? def.duration_sec,
                npc_name: obj.npc_name ?? rc?.npc_name ?? def.npc_name
            };
        },
        /** 로드된 미션 정규화: steps 있으면 단계형, 없으면 ALL_MISSION_COMPLETE형 (보상 필드는 루트에 평탄화) */
        normalizeLoadedMission(m) {
            const base = this.defaultMissionItem();
            if (m.steps && Array.isArray(m.steps) && m.steps.length > 0) {
                return {
                    ...base,
                    mission_type: m.mission_type || 'AD_WATCH_MINING',
                    detail_step_count: m.steps.length,
                    steps: m.steps.map(s => {
                        const flat = this.flattenReward(s, s.reward_type || 'mining');
                        return {
                            ...this.defaultStepItem(),
                            condition_count: Number(s.condition_count) ?? 0,
                            reward_type: s.reward_type || 'mining',
                            ...flat
                        };
                    })
                };
            }
            const rt = m.reward_type || 'mining';
            const flat = this.flattenReward(m, rt);
            return {
                ...base,
                mission_type: m.mission_type || 'ALL_MISSION_COMPLETE',
                condition_count: 1,
                reward_type: rt,
                ...flat,
                steps: base.steps,
                detail_step_count: base.detail_step_count
            };
        },
        /** 채굴기 기본 보너스 10, NPC 기본 보너스 100 */
        defaultRewardConfig(rewardType) {
            const bonus_pct = rewardType === 'npc' ? 100 : 10;
            return {
                bonus_pct,
                duration_sec: 86400,
                npc_name: ''
            };
        },
        syncDialogMissionListLength() {
            const n = Math.max(0, Number(this.dialog_mission_count) || 0);
            const list = this.dialog_mission_list;
            if (list.length < n) {
                for (let i = list.length; i < n; i++) {
                    list.push(this.defaultMissionItem());
                }
            } else if (list.length > n) {
                this.dialog_mission_list = list.slice(0, n);
            }
        },
        OnMissionTypeChange(mission) {
            if (mission.mission_type === 'ALL_MISSION_COMPLETE') {
                this.$set(mission, 'condition_count', 1);
                if (!mission.reward_type) this.$set(mission, 'reward_type', 'mining');
                const def = this.defaultRewardConfig(mission.reward_type || 'mining');
                this.$set(mission, 'bonus_pct', mission.bonus_pct ?? def.bonus_pct);
                this.$set(mission, 'duration_sec', mission.duration_sec ?? def.duration_sec);
                this.$set(mission, 'npc_name', mission.npc_name ?? def.npc_name);
            } else {
                if (!mission.steps || !Array.isArray(mission.steps)) this.$set(mission, 'steps', [this.defaultStepItem()]);
                if (mission.detail_step_count == null) this.$set(mission, 'detail_step_count', 1);
                this.syncDetailStepsForMission(mission);
            }
        },
        OpenRewardConfigPopup(idx) {
            const m = this.dialog_mission_list[idx];
            if (!m) return;
            const def = this.defaultRewardConfig(m.reward_type || 'mining');
            if (m.bonus_pct == null) this.$set(m, 'bonus_pct', def.bonus_pct);
            if (m.duration_sec == null) this.$set(m, 'duration_sec', def.duration_sec);
            if (m.npc_name == null) this.$set(m, 'npc_name', def.npc_name);
            this.reward_config_mission_index = idx;
            this.reward_config_step_index = -1;
            this.reward_config_popup = true;
        },
        OpenDetailConfigPopup(idx) {
            const m = this.dialog_mission_list[idx];
            if (!m) return;
            if (!m.steps || !Array.isArray(m.steps)) this.$set(m, 'steps', [this.defaultStepItem()]);
            if (m.detail_step_count == null) this.$set(m, 'detail_step_count', 1);
            this.syncDetailStepsForMission(m);
            m.steps.forEach(step => {
                const def = this.defaultRewardConfig(step.reward_type || 'mining');
                if (step.bonus_pct == null) this.$set(step, 'bonus_pct', def.bonus_pct);
                if (step.duration_sec == null) this.$set(step, 'duration_sec', def.duration_sec);
                if (step.npc_name == null) this.$set(step, 'npc_name', def.npc_name);
            });
            this.detail_mission_index = idx;
            this.detail_config_popup = true;
        },
        syncDetailSteps() {
            const m = this.currentDetailMission;
            if (m) this.syncDetailStepsForMission(m);
        },
        syncDetailStepsForMission(mission) {
            if (!mission || !Array.isArray(mission.steps)) return;
            const n = Math.max(1, Number(mission.detail_step_count) || 1);
            mission.detail_step_count = n;
            if (mission.steps.length < n) {
                for (let i = mission.steps.length; i < n; i++) {
                    mission.steps.push(this.defaultStepItem());
                }
            } else if (mission.steps.length > n) {
                mission.steps.splice(n);
            }
        },
        OpenStepRewardConfigPopup(missionIdx, stepIdx) {
            const m = this.dialog_mission_list[missionIdx];
            if (!m || !m.steps || !m.steps[stepIdx]) return;
            const step = m.steps[stepIdx];
            const def = this.defaultRewardConfig(step.reward_type || 'mining');
            if (step.bonus_pct == null) this.$set(step, 'bonus_pct', def.bonus_pct);
            if (step.duration_sec == null) this.$set(step, 'duration_sec', def.duration_sec);
            if (step.npc_name == null) this.$set(step, 'npc_name', def.npc_name);
            this.reward_config_mission_index = missionIdx;
            this.reward_config_step_index = stepIdx;
            this.reward_config_popup = true;
        },
        /** 상세설정 인라인 보상: 단계별 유지시간 프리셋 */
        SetStepRewardDuration(missionIdx, stepIdx, sec) {
            const m = this.dialog_mission_list[missionIdx];
            const step = m && m.steps && m.steps[stepIdx];
            if (step) this.$set(step, 'duration_sec', sec);
        },
        /** 유지시간(Sec)이 프리셋 값과 같으면 선택된 버튼으로 표시 */
        isDurationSelected(currentSec, targetSec) {
            return Number(currentSec) === Number(targetSec);
        },
        /** 단계형 미션: 단계별 개별조건(condition_count) 합계 (미션 블록에서 표시용) */
        missionConditionSum(mission) {
            if (!mission || !mission.steps || !Array.isArray(mission.steps)) return 0;
            return mission.steps.reduce((sum, s) => sum + (Number(s.condition_count) || 0), 0);
        },
        SetRewardDuration(idx, sec) {
            if (this.reward_config_step_index >= 0) {
                const m = this.dialog_mission_list[idx];
                const step = m && m.steps && m.steps[this.reward_config_step_index];
                if (step) this.$set(step, 'duration_sec', sec);
            } else {
                const m = this.dialog_mission_list[idx];
                if (m) this.$set(m, 'duration_sec', sec);
            }
        },
        /** 단계 한 개 보상 설정 여부 */
        isStepRewardConfigured(step) {
            if (!step) return false;
            if (step.reward_type === 'npc') {
                return !!(String(step.npc_name || '').trim());
            }
            if (step.reward_type === 'mining') {
                return !!(Number(step.bonus_pct) > 0);
            }
            return true;
        },
        /** 미션 보상(아이템) 설정 여부: 모든미션완료는 기존 로직, 단계형은 steps 전부 설정됨 */
        isMissionRewardConfigured(mission) {
            if (!mission) return false;
            if (mission.mission_type === 'ALL_MISSION_COMPLETE') {
                if (mission.reward_type === 'npc') {
                    return !!(String(mission.npc_name || '').trim());
                }
                if (mission.reward_type === 'mining') {
                    return !!(Number(mission.bonus_pct) > 0);
                }
                return true;
            }
            return !!(mission.steps && mission.steps.length > 0 && mission.steps.every(s => this.isStepRewardConfigured(s)));
        },

        OnClick_EditEventRolling(item, isMission = false) {
            this.current_event_tab = isMission ? 'mission' : 'normal';
            this.dialog_mode_edit = true;
            this.selected_event_rolling_pid = item.PID;
            this.dialog_is_main_banner = item.IS_MAIN_BANNER || 'N';
            this.dialog_title = item.TITLE || '';
            this.dialog_thumb_file = null;
            this.dialog_thumb_url = item.THUMB || '';
            
            if (!isMission) {
                this.dialog_event_tag = item.EVENT_TAG || '';
                this.dialog_desc = item.DESC || '';
            } else {
                const info = this.parseMissionInfo(item.INFO);
                const missions = info.missions && info.missions.length ? info.missions : (info.mission_type != null ? [{ mission_type: info.mission_type || 'AD_WATCH_MINING', condition_count: info.condition_count ?? info.mission_condition_count ?? 0, reward_type: info.reward_type || 'mining', reward_config: info.reward_config || this.defaultRewardConfig(info.reward_type || 'mining') }] : [this.defaultMissionItem()]);
                this.dialog_mission_count = missions.length;
                this.dialog_mission_list = missions.map(m => this.normalizeLoadedMission(m));
            }
            
            // 날짜와 시간 분리
            if (item.START_DT) {
                const startParts = item.START_DT.split(' ');
                this.dialog_start_dt = startParts[0] || '';
                this.dialog_start_time = startParts[1] ? startParts[1].substring(0, 5) : '00:00';
            } else {
                this.dialog_start_dt = '';
                this.dialog_start_time = '00:00';
            }
            
            if (item.END_DT) {
                const endParts = item.END_DT.split(' ');
                this.dialog_end_dt = endParts[0] || '';
                this.dialog_end_time = endParts[1] ? endParts[1].substring(0, 5) : '23:59';
            } else {
                this.dialog_end_dt = '';
                this.dialog_end_time = '23:59';
            }
            
            this.dialog_is_enable = item.IS_ENABLE || 'Y';
            this.dialog_was_enabled_on_open = isMission && (item.IS_ENABLE === 'Y');
            
            // 일반 이벤트: INFO 파싱, 액션타입/키 로드, JSON 표시 (기존 키 유지)
            if (!isMission) {
                let parsed = {};
                if (item.INFO) {
                    try {
                        parsed = typeof item.INFO === 'string' ? JSON.parse(item.INFO) : (item.INFO || {});
                    } catch (e) {
                        parsed = {};
                    }
                }
                this.dialog_action_type = parsed.action_type || 'link';
                this.dialog_action_key = parsed.action_key != null ? String(parsed.action_key) : '';
                // action_type, action_key가 없으면 기본값으로 추가하여 JSON 표시 (다른 키는 유지)
                const merged = { ...parsed, action_type: this.dialog_action_type, action_key: this.dialog_action_key };
                this.dialog_info_text = JSON.stringify(merged, null, 2);
            }
            
            this.dialog_event_rolling = true;
        },

        async OnClick_SetMainBanner() {
            if (!this.selected_event_rolling_pid) return;
            this.loadingMainBanner = true;
            try {
                const eventType = this.current_event_tab === 'mission' ? 'MISSION' : 'ROLLING';
                await this.CPU_SET_MAIN_BANNER({ pid: this.selected_event_rolling_pid, event_type: eventType });
                this.dialog_is_main_banner = 'Y';
                this.LoadEventRollingList();
                this.LoadMissionEventRollingList();
                alert('메인 배너로 지정되었습니다.');
            } catch (e) {
                alert(e?.message || e || '요청에 실패했습니다.');
            } finally {
                this.loadingMainBanner = false;
            }
        },

        handleFileChange(file) {
            // 파일 선택 시 처리
        },
        /** 미션형 이벤트 썸네일 영역 클릭 시 파일 선택 열기 */
        triggerMissionThumbFileInput() {
            const ref = this.$refs.missionThumbFileInput;
            if (!ref || !ref.$el) return;
            const input = ref.$el.querySelector('input[type="file"]');
            if (input) input.click();
        },

        async OnSave_EventRolling() {
            const isMission = this.current_event_tab === 'mission';
            
            // 필수 필드 검증
            if (isMission) {
                if (!this.dialog_title || !this.dialog_start_dt || !this.dialog_end_dt) {
                    alert('필수 항목(제목, 시작일, 종료일)을 모두 입력해주세요.');
                    return;
                }
            } else {
                if (!this.dialog_event_tag || !this.dialog_title || !this.dialog_desc || !this.dialog_start_dt || !this.dialog_end_dt) {
                    alert('필수 항목(이벤트 태그, 제목, 설명, 시작일, 종료일)을 모두 입력해주세요.');
                    return;
                }
            }

            // 썸네일 검증 (생성 시에만 필수)
            if (!this.dialog_mode_edit && !this.dialog_thumb_file) {
                alert('썸네일 이미지를 선택해주세요.');
                return;
            }

            // 날짜와 시간 결합
            const start_dt = `${this.dialog_start_dt} ${this.dialog_start_time}:00`;
            const end_dt = `${this.dialog_end_dt} ${this.dialog_end_time}:00`;

            // 날짜/시간 검증
            const startDateTime = new Date(start_dt);
            const endDateTime = new Date(end_dt);
            if (startDateTime >= endDateTime) {
                alert('시작일시가 종료일시보다 늦거나 같을 수 없습니다.');
                return;
            }

            this.loadingData = true;

            let thumb_url = this.dialog_thumb_url;

            // 새 이미지가 업로드된 경우
            if (this.dialog_thumb_file) {
                const maxFileSize = 1024 * 1024; // 1MB
                if (this.dialog_thumb_file.size > maxFileSize) {
                    this.loadingData = false;
                    alert('파일 크기가 1MB를 초과합니다. 더 작은 파일을 선택해주세요.');
                    return;
                }

                thumb_url = "project_cpu/images/eventrolling/banner/" + this.Utill_CreateNewImageName(this.dialog_thumb_file.name);
                try {
                    await FileUpload_Async(this.dialog_thumb_file, thumb_url);
                } catch (error) {
                    this.loadingData = false;
                    console.error('이미지 업로드 실패:', error);
                    alert('이미지 업로드에 실패했습니다.');
                    return;
                }
            }

            if (isMission) {
                this.syncDialogMissionListLength();
                const notConfigured = this.dialog_mission_list
                    .map((m, idx) => ({ mission: m, idx: idx + 1 }))
                    .filter(({ mission }) => !this.isMissionRewardConfigured(mission));
                if (notConfigured.length > 0) {
                    const list = notConfigured.map(({ idx }) => `미션 ${idx}`).join(', ');
                    alert(`보상(아이템) 설정이 되지 않은 미션이 있습니다.\n\n미설정: ${list}\n\n"보상설정" 또는 "상세설정" 버튼을 눌러 설정해주세요.`);
                    return;
                }
                const missions = this.dialog_mission_list.map(m => {
                    if (m.mission_type === 'ALL_MISSION_COMPLETE') {
                        return {
                            mission_type: 'ALL_MISSION_COMPLETE',
                            condition_count: 1,
                            reward_type: m.reward_type || 'mining',
                            npc_name: m.npc_name ?? '',
                            bonus_pct: m.bonus_pct,
                            duration_sec: m.duration_sec
                        };
                    }
                    const steps = (m.steps || []).map(s => ({
                        condition_count: Number(s.condition_count) || 0,
                        reward_type: s.reward_type || 'mining',
                        npc_name: s.npc_name ?? '',
                        bonus_pct: s.bonus_pct,
                        duration_sec: s.duration_sec
                    }));
                    return { mission_type: m.mission_type || 'AD_WATCH_MINING', steps };
                });
                const info = {
                    mission_count: missions.length,
                    missions
                };
                if (this.dialog_mode_edit) {
                    this.EDIT_EVENT_MISSION({
                        pid: this.selected_event_rolling_pid,
                        title: this.dialog_title,
                        thumb: thumb_url,
                        start_dt,
                        end_dt,
                        is_enable: this.dialog_is_enable,
                        info
                    })
                    .then(() => {
                        this.loadingData = false;
                        alert('미션형 이벤트가 수정되었습니다.');
                        this.CloseEventRollingDialog();
                        this.LoadMissionEventRollingList();
                    })
                    .catch((err) => {
                        this.loadingData = false;
                        console.error('이벤트 미션 수정 실패:', err);
                        alert('이벤트 미션 수정에 실패했습니다: ' + (err || '알 수 없는 오류'));
                    });
                } else {
                    this.CREATE_EVENT_MISSION({
                        title: this.dialog_title,
                        thumb: thumb_url,
                        start_dt,
                        end_dt,
                        is_enable: this.dialog_is_enable,
                        info
                    })
                    .then(() => {
                        this.loadingData = false;
                        alert('미션형 이벤트가 등록되었습니다.');
                        this.CloseEventRollingDialog();
                        this.LoadMissionEventRollingList();
                    })
                    .catch((err) => {
                        this.loadingData = false;
                        console.error('이벤트 미션 생성 실패:', err);
                        alert('이벤트 미션 등록에 실패했습니다: ' + (err || '알 수 없는 오류'));
                    });
                }
                return;
            }

            // 일반 이벤트: INFO 파싱 (기존 키 유지) + 액션타입/키 병합
            let info = {};
            if (this.dialog_info_text && this.dialog_info_text.trim()) {
                try {
                    info = JSON.parse(this.dialog_info_text);
                    if (info && typeof info !== 'object') info = {};
                } catch (e) {
                    this.loadingData = false;
                    alert('정보 필드가 올바른 JSON 형식이 아닙니다.');
                    return;
                }
            }
            info = info || {};
            info.action_type = this.dialog_action_type || 'link';
            info.action_key = this.dialog_action_key != null ? String(this.dialog_action_key) : '';

            if (this.dialog_mode_edit) {
                this.EDIT_EVENT_ROLLING({
                    pid: this.selected_event_rolling_pid,
                    event_tag: this.dialog_event_tag,
                    title: this.dialog_title,
                    desc: this.dialog_desc,
                    thumb: thumb_url,
                    start_dt,
                    end_dt,
                    is_enable: this.dialog_is_enable,
                    info
                })
                .then((response) => {
                    this.loadingData = false;
                    alert('이벤트 롤링이 수정되었습니다.');
                    this.CloseEventRollingDialog();
                    this.LoadEventRollingList();
                })
                .catch((err) => {
                    this.loadingData = false;
                    console.error('이벤트 롤링 수정 실패:', err);
                    alert('이벤트 롤링 수정에 실패했습니다: ' + (err || '알 수 없는 오류'));
                });
            } else {
                this.CREATE_EVENT_ROLLING({
                    event_tag: this.dialog_event_tag,
                    title: this.dialog_title,
                    desc: this.dialog_desc,
                    thumb: thumb_url,
                    start_dt,
                    end_dt,
                    is_enable: this.dialog_is_enable,
                    info
                })
                .then((response) => {
                    this.loadingData = false;
                    alert('이벤트 롤링이 등록되었습니다.');
                    this.CloseEventRollingDialog();
                    this.LoadEventRollingList();
                })
                .catch((err) => {
                    this.loadingData = false;
                    console.error('이벤트 롤링 생성 실패:', err);
                    alert('이벤트 롤링 등록에 실패했습니다: ' + (err || '알 수 없는 오류'));
                });
            }
        },

        CloseEventRollingDialog() {
            this.dialog_event_rolling = false;
            this.dialog_mode_edit = false;
            this.selected_event_rolling_pid = null;
        },

        Utill_CreateNewImageName(originalFileName) {
            const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.'));
            const randomString = Math.random().toString(36).substring(2, 18);
            return randomString + fileExtension;
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleString('ko-KR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        formatInfo(info) {
            if (!info) return '';
            try {
                const parsed = typeof info === 'string' ? JSON.parse(info) : info;
                return JSON.stringify(parsed, null, 2);
            } catch (e) {
                return info;
            }
        },
        /** 미션형 이벤트 INFO JSON 파싱 → { mission_count, missions: [{ mission_type, condition_count, reward_type }, ...] } */
        parseMissionInfo(info) {
            if (!info) return { missions: [] };
            try {
                const parsed = typeof info === 'string' ? JSON.parse(info) : info;
                const missions = Array.isArray(parsed.missions) ? parsed.missions : (parsed.mission_type != null ? [{ mission_type: parsed.mission_type, condition_count: parsed.condition_count ?? parsed.mission_condition_count ?? 0, reward_type: parsed.reward_type || 'mining' }] : []);
                const first = missions[0];
                return {
                    mission_count: parsed.mission_count ?? missions.length,
                    missions,
                    condition_count: first?.condition_count ?? first?.mission_condition_count,
                    mission_type: first?.mission_type
                };
            } catch (e) {
                return { missions: [] };
            }
        },
        /** 미션 타입 value → 표시 텍스트 */
        missionTypeText(value) {
            if (value == null || value === '') return '-';
            const opt = this.mission_type_options.find(o => o.value === value);
            return opt ? opt.text : value;
        },
        /** 보상 타입 value → 표시 텍스트 (우편 보내는 곳 참고) */
        rewardTypeText(value) {
            if (value == null || value === '') return '-';
            const opt = this.reward_type_options.find(o => o.value === value);
            return opt ? opt.text : value;
        },

        /** 티켓이벤트: 비활성화/기간만료 표시용 텍스트 */
        getTicketEventStatusText(item) {
            const enableText = item.IS_ENABLE === 'Y' ? '활성화' : '비활성화';
            const expired = this.isEventExpired(item);
            return expired ? `${enableText}/기간만료` : enableText;
        },
        getTicketEventStatusClass(item) {
            const disabled = item.IS_ENABLE === 'N';
            const expired = this.isEventExpired(item);
            return disabled || expired ? 'error--text' : 'success--text';
        },
        /** 기간만료 여부 (END_DT < now) */
        isEventExpired(item) {
            if (!item || !item.END_DT) return false;
            const endDate = new Date(item.END_DT);
            return !isNaN(endDate.getTime()) && new Date() > endDate;
        },
        isEventActive(item) {
            if(item.IS_ENABLE == 'N'){
                return false;
            }
            // 기간 체크만 수행 (활성화 여부와 무관하게 현재 시간이 기간 내에 있는지 확인)
            const now = new Date();
            
            // START_DT와 END_DT가 이미 날짜+시간 형식이므로 그대로 사용
            const startDate = new Date(item.START_DT);
            const endDate = new Date(item.END_DT);

            // 날짜 파싱이 실패한 경우 처리
            if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
                console.error('날짜 파싱 실패:', item.START_DT, item.END_DT);
                return false;
            }

            // 현재 시간이 시작일시 이후이고 종료일시 이전인지 확인
            return now >= startDate && now <= endDate;
        },
        isEventMainBanner(item) {
            return this.isEventActive(item) && item.IS_MAIN_BANNER === 'Y';
        },
        eventCardAccentColor(item) {
            if (!this.isEventActive(item)) return 'grey';
            return item.IS_MAIN_BANNER === 'Y' ? 'orange darken-2' : 'primary';
        },
        eventCardTitleClass(item) {
            if (!this.isEventActive(item)) return 'grey darken-1 white--text';
            return item.IS_MAIN_BANNER === 'Y' ? 'orange darken-2 white--text' : 'primary white--text';
        },
        /** 설정(액션타입, 키) → JSON 실시간 동기화 (다른 키 유지, action_type/action_key는 설정값으로 고정) */
        syncActionToInfoJson() {
            let parsed = {};
            if (this.dialog_info_text && this.dialog_info_text.trim()) {
                try {
                    parsed = JSON.parse(this.dialog_info_text);
                    if (!parsed || typeof parsed !== 'object') parsed = {};
                } catch (e) {
                    parsed = {};
                }
            }
            parsed.action_type = this.dialog_action_type || 'link';
            parsed.action_key = this.dialog_action_key != null ? String(this.dialog_action_key) : '';
            this.dialog_info_text = JSON.stringify(parsed, null, 2);
        },
    },

    watch: {
        dialog_action_type() {
            if (this.current_event_tab !== 'normal' || this._syncing_from_json) return;
            this.syncActionToInfoJson();
        },
        dialog_action_key() {
            if (this.current_event_tab !== 'normal' || this._syncing_from_json) return;
            this.syncActionToInfoJson();
        },
        /** JSON 직접 수정 시 → 설정(액션타입, 키) 반영 */
        dialog_info_text() {
            if (this.current_event_tab !== 'normal' || this._syncing_from_json) return;
            try {
                const parsed = JSON.parse(this.dialog_info_text || '{}');
                if (parsed && typeof parsed === 'object') {
                    this._syncing_from_json = true;
                    if (parsed.action_type != null) this.dialog_action_type = String(parsed.action_type);
                    if (parsed.action_key != null) this.dialog_action_key = String(parsed.action_key);
                    this.$nextTick(() => { this._syncing_from_json = false; });
                }
            } catch (e) { /* JSON 파싱 실패(입력 중 등) 시 무시 */ }
        },
    },

    computed: {
        /** 미션형 이벤트 수정 시 열었을 때 이미 활성화였던 경우: 활성화 토글만 허용, 나머지 수정 불가 */
        missionFormLockedWhenActive() {
            return this.current_event_tab === 'mission' && this.dialog_mode_edit && this.dialog_was_enabled_on_open;
        },
        isLive() {
            return config.isLive;
        },
        currentDetailMission() {
            if (this.detail_mission_index < 0 || !this.dialog_mission_list[this.detail_mission_index]) return null;
            return this.dialog_mission_list[this.detail_mission_index];
        },
        /** 상세설정: 단계별 개별조건(condition_count)의 합 */
        detailConditionSum() {
            const m = this.currentDetailMission;
            if (!m || !m.steps || !Array.isArray(m.steps)) return 0;
            return m.steps.reduce((sum, s) => sum + (Number(s.condition_count) || 0), 0);
        },
        currentRewardMission() {
            if (this.reward_config_mission_index < 0 || !this.dialog_mission_list[this.reward_config_mission_index]) return null;
            const m = this.dialog_mission_list[this.reward_config_mission_index];
            if (this.reward_config_step_index >= 0) {
                if (!m.steps || !m.steps[this.reward_config_step_index]) return null;
                return m.steps[this.reward_config_step_index];
            }
            return m;
        }
    }
};
</script>

<style scoped>
@media (max-width: 600px) {
  .v-toolbar__content { flex-wrap: wrap; height: auto !important; padding: 8px; }
  .v-tabs { max-width: 100%; }
}

.tab-item {
    min-width: 140px;
}
.tab-item-ticket.v-tab--active {
    color: #7c4dff !important;
}
.tab-text {
    font-weight: 500;
    font-size: 0.9rem;
}
.toolbar-custom {
    border-bottom: 1px solid #e0e0e0;
}
.toolbar-title-custom {
    font-size: 1rem;
    font-weight: 600;
    color: #424242;
}
.toolbar-text {
    margin-left: 8px;
}

/* 티켓이벤트 리스트 아이템 */
.ticket-list-item-active {
    border-left: 4px solid #7c4dff;
    background-color: rgba(124, 77, 255, 0.04);
}
.ticket-list-item-inactive {
    border-left: 4px solid #bdbdbd;
    background-color: rgba(158, 158, 158, 0.06);
}
.ticket-list-item-active:hover,
.ticket-list-item-inactive:hover {
    background-color: rgba(124, 77, 255, 0.08);
}

/* 활성화/비활성화 컬러 강조 (다이얼로그 내 활성화 선택 영역) */
.enable-select-wrap {
    border-radius: 8px;
    padding: 4px 0 4px 12px;
    margin-left: -12px;
    transition: background-color 0.2s, border-color 0.2s;
}
.enable-select-wrap.enable-y {
    border-left: 4px solid #4caf50;
    background-color: rgba(76, 175, 80, 0.06);
}
.enable-select-wrap.enable-n {
    border-left: 4px solid #f44336;
    background-color: rgba(244, 67, 54, 0.06);
}

/* 미션형 이벤트 다이얼로그: 상단 정리 + 미션 블록 높이 축소 */
.mission-dialog-top .mission-top-row {
    align-items: flex-start;
}
/* 썸네일 전용 왼쪽 영역 (구분선·배경으로 명확히 구분) */
.mission-dialog-top .mission-thumb-col {
    flex: 0 0 auto;
    max-width: none;
}
@media (min-width: 960px) {
    .mission-dialog-top .mission-thumb-col {
        width: 220px;
        min-width: 220px;
    }
}
.mission-dialog-top .mission-thumb-zone {
    padding: 12px 16px 12px 0;
    margin-right: 16px;
    border-right: 2px solid #e0e0e0;
    background: #f5f5f5;
    border-radius: 0 8px 8px 0;
    min-height: 140px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
@media (max-width: 959px) {
    .mission-dialog-top .mission-thumb-zone {
        margin-right: 0;
        padding-right: 0;
        border-right: none;
        border-bottom: 2px solid #e0e0e0;
        border-radius: 8px 8px 0 0;
        padding-bottom: 12px;
        margin-bottom: 12px;
    }
}
.mission-dialog-top .mission-thumb-zone-label {
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    color: #616161;
    margin-bottom: 8px;
}
.mission-dialog-top .mission-form-col {
    min-width: 0;
}
/* 썸네일 비율 3:2 (가로:세로), 가로 180px → 세로 120px, 내용 중앙 정렬 */
.mission-dialog-top .mission-thumb-wrap {
    width: 180px;
    height: 120px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    background: #fff;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.mission-dialog-top .mission-thumb-wrap:hover {
    background: #fafafa;
}
.mission-dialog-top .mission-thumb-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.mission-dialog-top .mission-thumb-placeholder {
    display: block;
    flex-shrink: 0;
}
.mission-dialog-top .mission-thumb-input {
    max-width: 180px;
    margin: 0 auto;
}
.mission-dialog-top .mission-thumb-input >>> .v-input__control {
    min-height: 36px;
}
.mission-dialog-top .mission-period-row {
    padding: 4px 0;
    margin-top: 4px;
}
.mission-dialog-top .mission-blocks-wrap {
    margin-top: 8px;
}
.mission-dialog-top .mission-block {
    padding: 10px 16px 10px 14px;
    margin-bottom: 8px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
}
.mission-dialog-top .mission-block.mission-reward-configured {
    background: rgba(76, 175, 80, 0.08);
    border-left: 3px solid #4caf50;
}
.mission-dialog-top .mission-block.mission-reward-not-configured {
    background: rgba(244, 67, 54, 0.08);
    border-left: 3px solid #f44336;
}
.mission-dialog-top .mission-block:last-child {
    margin-bottom: 0;
}
.mission-dialog-top .mission-block-row {
    margin-left: -6px;
    margin-right: -6px;
}
.mission-dialog-top .mission-block-row .v-col {
    padding-left: 6px;
    padding-right: 6px;
}
.mission-dialog-top .mission-reward-btn-col {
    padding-right: 4px;
    justify-content: flex-start;
}
.mission-dialog-top .mission-reward-btn {
    flex-shrink: 0;
}
.mission-dialog-top .mission-block-label {
    display: block;
    font-size: 0.7rem;
    color: #757575;
    margin-bottom: 4px;
}

/* 상세설정 다이얼로그: 단계당 한 줄 (가로 꽉 채워서 가독성) */
.detail-config-dialog .detail-steps-wrap {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.detail-config-dialog .detail-step-row {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background: #fafafa;
}
.detail-config-dialog .detail-step-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
}
.detail-config-dialog .detail-step-num-col {
    min-width: 48px;
}
.detail-config-dialog .detail-step-num {
    font-size: 0.8rem;
    font-weight: 700;
    color: #424242;
    white-space: nowrap;
}
</style>
